var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table", class: _vm.tableClass }, [
    _c("thead", { staticClass: "thead-dark" }, [
      _c("th", [_vm._v("#")]),
      _c("th", [_vm._v(_vm._s(this.$t("__menuId")))]),
      _c(
        "th",
        {
          staticStyle: { cursor: "pointer" },
          on: { click: _vm.onClickMenuNameColumnHeader },
        },
        [
          _vm._v(
            " " +
              _vm._s(this.$t("__menuName")) +
              " " +
              _vm._s(_vm.getSortOrderLabel(_vm.menuNameColumnSortState)) +
              " "
          ),
        ]
      ),
      _c("th", [_vm._v(_vm._s(this.$t("__workTime")))]),
      _c("th", [_vm._v(_vm._s(this.$t("__segment")))]),
      _c("th"),
    ]),
    _c(
      "tbody",
      _vm._l(_vm.data, function (item, index) {
        return _c("tr", { key: index }, [
          _c("td", [_vm._v(_vm._s(index + 1))]),
          _c("td", [_vm._v(_vm._s(item.id))]),
          _c("td", [_vm._v(_vm._s(item.name))]),
          _c("td", [
            _vm._v(
              _vm._s(_vm.toDateString(item.start_time)) +
                " ~ " +
                _vm._s(_vm.toDateString(item.end_time))
            ),
          ]),
          _c("td", [_vm._v(_vm._s(item.segmentName))]),
          _c("td", { staticStyle: { width: "80px" } }, [
            _c(
              "a",
              {
                staticClass: "editStoryIcon",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function ($event) {
                    return _vm.editRichMenu(item)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-edit mx-1" })]
            ),
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function ($event) {
                    return _vm.deleteRichMenu(item, index)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-trash text-danger mx-1" })]
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }